import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-view_nav-fold",
  "use": "icon-sheet-view_nav-fold-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-sheet-view_nav-fold\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.874 9.874L6.136 5.63l3.738-4.243\" /><path d=\"M6.35 9.874L2.612 5.63 6.35 1.388\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol